import React, { useContext, useState, useEffect } from "react";
import { useHistory } from "react-router-dom";

import { makeStyles } from "@material-ui/core/styles";
import {
	IconButton,
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
	Button,
	TextField,
	Tooltip,
	Typography,
} from "@material-ui/core";
import { MoreVert, LocalOfferOutlined, Star, StarOutline } from "@material-ui/icons";
import { PinCheio, PinVazado } from "../IconePin";

import api from "../../services/api";
import TicketOptionsMenu from "../TicketOptionsMenu";
import TicketTagModal from "../TicketTagModal";
import toastError from "../../errors/toastError";
import { toast } from "react-toastify";
import { AuthContext } from "../../context/Auth/AuthContext";
import { FavoritosContext } from "../../context/Favoritos/FavoritosContext";

const useStyles = makeStyles(theme => ({
	actionButtons: {
		marginRight: 12,
		flex: "none",
		alignSelf: "center",
		marginLeft: "auto",
		display: "flex",
		alignItems: "center",
		flexWrap: "wrap",
		gap: "4px",
	},
}));

const TicketActionButtons = ({ ticket, contact }) => {
	const classes = useStyles();
	const history = useHistory();
	const [anchorEl, setAnchorEl] = useState(null);
	const [loading, setLoading] = useState(false);
	const [tagModalOpen, setTagModalOpen] = useState(false);
	const ticketOptionsMenuOpen = Boolean(anchorEl);
	const { user } = useContext(AuthContext);

	const {
		ehFavorito,
		ehFixado,
		alternarFavorito,
		alternarFixado,
	} = useContext(FavoritosContext);

	const idDoContato = ticket.contactId ?? ticket.contact?.id;
	const currentIsFavorite = ehFavorito(idDoContato);
	const fixado = ehFixado(idDoContato);

	const handleOpenTicketOptionsMenu = e => {
		setAnchorEl(e.currentTarget);
	};

	const handleCloseTicketOptionsMenu = e => {
		setAnchorEl(null);
	};

	const handleUpdateTicketStatus = async (e, status, userId) => {
		setLoading(true);
		try {
			await api.put(`/tickets/${ticket.id}`, {
				status: status,
				userId: userId || null,
			});

			setLoading(false);
			if (status === "open") {
				history.push(`/atendimentos/${ticket.id}`);
			} else {
				history.push("/atendimentos");
			}
		} catch (err) {
			setLoading(false);
			toastError(err);
		}
	};

	const handleToggleFavorite = () => alternarFavorito(idDoContato);

	const handleToggleFixado = async () => {
		const eraFixado = fixado;
		await alternarFixado(idDoContato);
		toast.success(
			eraFixado ? "Contato desafixado." : "Contato fixado no topo."
		);
	};

	return (
		<div className={classes.actionButtons}>
			<Tooltip title={currentIsFavorite ? "Remover dos meus favoritos" : "Favoritar (só para você)"}>
				<IconButton size="small" onClick={handleToggleFavorite}>
					{currentIsFavorite ? (
						<Star style={{ color: "#ffc107" }} />
					) : (
						<StarOutline />
					)}
				</IconButton>
			</Tooltip>

			<Tooltip title={fixado ? "Desafixar do topo" : "Fixar no topo (máx. 3)"}>
				<IconButton size="small" onClick={handleToggleFixado}>
					{fixado ? (
						<PinCheio style={{ color: "#0D9488" }} fontSize="small" />
					) : (
						<PinVazado fontSize="small" />
					)}
				</IconButton>
			</Tooltip>
			<IconButton size="small" onClick={() => setTagModalOpen(true)}>
				<LocalOfferOutlined fontSize="small" />
			</IconButton>
			<TicketTagModal
				open={tagModalOpen}
				onClose={() => setTagModalOpen(false)}
				ticketId={ticket.id}
				ticketTags={ticket.tags}
			/>

			{}
			{}
			<IconButton
				size="small"
				onClick={handleOpenTicketOptionsMenu}
				disabled={loading}
			>
				<MoreVert />
			</IconButton>
			<TicketOptionsMenu
				ticket={ticket}
				anchorEl={anchorEl}
				menuOpen={ticketOptionsMenuOpen}
				handleClose={handleCloseTicketOptionsMenu}
				handleUpdateTicketStatus={handleUpdateTicketStatus}
			/>
		</div>
	);
};

export default TicketActionButtons;
